import { NgModule } from '@angular/core';
import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { NgxPaginationModule } from 'ngx-pagination';

import { routing } from './wallet.routing';
import { NgxMaskModule   } from 'ngx-mask-2';
import { WalletComponent } from './wallet.component';
import { WalletService } from './wallet.service';
import { ManualDepositComponent } from './manual-deposit/manual-deposit.component';
import { TransactionComponent } from './transaction/transaction.component';
import { RequestComponent } from './request/request.component';
import { MaterialComponentsModule } from '../../materials.module';

@NgModule({
  declarations: [
    WalletComponent,
    ManualDepositComponent,
    TransactionComponent,
    RequestComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialComponentsModule,
    SharedModule,
    AutoCompleteModule,
    NgxPaginationModule,
    routing,
    NgxMaskModule.forRoot()
  ],
  providers: [WalletService, DecimalPipe, DatePipe],
})
export class WalletModule {}
